import AuthService from '@/services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const accessToken = JSON.parse(localStorage.getItem('accessToken'));
const initialState = user
  ? { status: { loggedIn: true }, user, accessToken }
  : { status: { loggedIn: false }, user: null, accessToken: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        result => {
          commit('loginSuccess', result);
          return Promise.resolve(result);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    loginSuccess(state, result) {
      state.status.loggedIn = true;
      state.user = result.user;
      state.accessToken = result.accessToken;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.accessToken = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.accessToken = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};
